/**
 * Hub « Bloc de contenu » : onglets Home / Boutique.
 * Le rattachement se fait via la clé widget API (`bloc_cta_home`, `bloc_cta_shop`, …).
 */
import { Home, Store, type LucideIcon } from 'lucide-react';
import type {
  WidgetWidgetReadModel,
  WidgetWorkspaceWidgetWorkspaceReadModel
} from '@r/api/generated/client.schemas.ts';
import {
  type ContentBlockPageId,
  isWidgetKeyForContentBlockPage
} from '@r/helpers/widget-workspace-slides.ts';

export const CONTENT_BLOCK_PAGES: {
  id: ContentBlockPageId;
  labelKey: string;
  Icon: LucideIcon;
}[] = [
  { id: 'home', labelKey: 'admin.contentblock.hub.page.home', Icon: Home },
  { id: 'shop', labelKey: 'admin.contentblock.hub.page.shop', Icon: Store }
];

type WidgetWorkspace = WidgetWorkspaceWidgetWorkspaceReadModel;

/** Instances `widget_workspace` déjà créées pour une page (ordre géré par sortOrder). */
export const filterBlocksForPage = (
  workspaces: WidgetWorkspace[] | undefined,
  pageId: ContentBlockPageId
): WidgetWorkspace[] => {
  if (!workspaces) return [];
  return workspaces.filter((workspace) =>
    isWidgetKeyForContentBlockPage(workspace.widget?.key, pageId)
  );
};

/** Modèles widget admin (`/admin/widgets`) utilisables pour « Ajouter un bloc » sur cette page. */
export const filterWidgetsForPage = (
  widgets: WidgetWidgetReadModel[] | undefined,
  pageId: ContentBlockPageId
): WidgetWidgetReadModel[] => {
  if (!widgets) return [];
  return widgets.filter((widget) => isWidgetKeyForContentBlockPage(widget.key, pageId));
};
